import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./index.scss";
import { toast } from "react-toastify";
import { useTranslation } from "../../../hooks/useTranslation";
export default function ContactSection() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    accepted: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = {};

    try {
      const response = await fetch(
        "https://api.msit-corporate.msit-demo.fr/api/contact",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        toast.success(t('contactSuccessMessage'));
        setFormData({
          name: "",
          email: "",
          accepted: false,
          message: "",
        });
      } else {
        const errorData = await response.json();
        console.error("Erreur serveur :", errorData);
        toast.error(t('contactErrorMessage'));
      }
    } catch (error) {
      console.error("Erreur réseau :", error);
      toast.error(t('contactNetworkError'));
    }
  };

  return (
    <section className="contact-section" id="contact">
      <Container>
        <Row className="align-items-start">
          {/* Texte gauche */}
          <Col md={6} className="left-text">
            <h2>
              {t('contactTitle')} <br />
              <span>
                {t('contactSubtitle')}
              </span>
            </h2>
          </Col>

          {/* Formulaire droite */}
          <Col md={6} className="right-form">
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="name" className="mb-4">
                <Form.Control
                  type="text"
                  name="name"
                  placeholder={t('contactNamePlaceholder')}
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="email" className="mb-4">
                <Form.Control
                  type="email"
                  name="email"
                  placeholder={t('contactEmailPlaceholder')}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="message" className="mb-4">
                <Form.Control
                  as="textarea"
                  name="message"
                  rows={3}
                  placeholder={t('contactMessagePlaceholder')}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group
                controlId="accepted"
                className="mb-3 d-flex align-items-center">
                <Form.Check
                  type="checkbox"
                  name="accepted"
                  checked={formData.accepted}
                  onChange={handleChange}
                />
                <Form.Label className="ms-2">
                  {t('contactAcceptText')}{" "}
                  <a href="/privacy-policy" className="link">
                    {t('contactPrivacyPolicy')}
                  </a>
                </Form.Label>
              </Form.Group>

              <Button type="submit" className="submit-btn mt-5">
                {t('contactSubmitButton')}
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
